import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getCurrentProject } from '../../modules/project';
import AssignRole from './AssignRole';

const TeamTableAction = ({
  fetchUsersData,
  users,
  setOpenModal,
  open,
  mode = 'add',
  selectedUser,
  setMode
}) => {
  const { projectId } = useParams();
  const [currentProject, setCurrentProject] = React.useState(null);
  const fetchCurrentProject = async () => {
    if (projectId) {
      const response = await getCurrentProject(projectId);
      setCurrentProject(response);
    } else {
      return null;
    }
  };

  useEffect(() => {
    fetchCurrentProject();
  }, [projectId]);
  return (
    <>
      <AssignRole
        fetchUsersData={fetchUsersData}
        associatedUsers={users}
        setOpen={setOpenModal}
        open={open}
        currentProject={currentProject}
        mode={mode}
        setMode={setMode}
        selectedUser={selectedUser}
      />
    </>
  );
};

export default TeamTableAction;
